import type { BreadcrumbItem } from "~/shared/ui/ChatBreadcrumb";

interface BuildChatBreadcrumbInput {
    workspaceName?: string;
    workspaceId?: string | null;
    projectName?: string;
    projectId?: string | null;
    sceneName?: string;
    chatLabel: string;
}

// workspace → (project) → (scene) → chat. Workspace всегда первая крошка
// (включая personal). Scene показываем только если есть project: модель чата
// запрещает `sceneId IS NOT NULL && projectId IS NULL` (см. project_chat_entity_model).
export function buildChatBreadcrumb({
    workspaceName,
    workspaceId,
    projectName,
    projectId,
    sceneName,
    chatLabel,
}: BuildChatBreadcrumbInput): BreadcrumbItem[] {
    const trail: BreadcrumbItem[] = [];
    if (workspaceName) {
        trail.push({
            id: "workspace",
            label: workspaceName,
            href: workspaceId ? `/workspace/${workspaceId}` : undefined,
        });
    }
    if (projectName && projectId) {
        trail.push({ id: "project", label: projectName, href: `/projects/${projectId}` });
    }
    if (sceneName && projectId) {
        trail.push({ id: "scene", label: sceneName });
    }
    trail.push({ id: "chat", label: chatLabel });
    return trail;
}
